// APP TEXT
export const APP_TITLE = 'Enterprise';
export const FOOTER_FFNII = 'Fujitsu Frontech Innovations Inc.';
export const FOOTER_COPYRIGHT = `© Copyright ${new Date().getFullYear()}`;
export const FOOTER_VERSION = `Version: ${process.env.REACT_APP_VERSION}`;
export const TOOLTIP_LIGHT_MODE = 'Switch to light mode';
export const TOOLTIP_DARK_MODE = 'Switch to dark mode';
export const TOOLTIP_USER_ACCOUNT = 'User Account';
export const TOOLTIP_SETTINGS = 'Settings';
export const UPDATE_WGT_RECORD_TITLE = 'Update Weight Record';
export const UPDATE_WGT_RECORD_ITEM_NAME = 'Name: ';
export const UPDATE_WGT_RECORD_ITEM_BARCODE = 'Barcode: ';
export const UPDATE_WGT_RECORD_WGTS = 'Weights';
export const UPDATE_WGT_RECORD_STANDARD_WGT = 'Recommended weight: ';
export const RECOMMENDED_WEIGHT = 'Recommended weight';
export const ALERT_TYPE = 'Alert type';
export const WEIGHT_CATEGORY = 'Weight category';
export const UPDATE_WGT_RECORD_STANDARD_WGT_UNIT = 'clbs';
export const ITEM_DETAILS = 'Item details:';
export const SELECT_WEIGHT_CATEGORY =
  'Select the supported Clean action to apply:';
export const MIXED_WEIGHT_CATEGORY = 'Mixed weights';
export const LIGHT_WEIGHT_CATEGORY = 'Light item';
export const MEDIUM_WEIGHT_CATEGORY = 'Medium item';
export const HEAVY_WEIGHT_CATEGORY = 'Heavy item';
export const UPDATE_WGT_RECORD_STANDARD_SET_WGT = 'Set weight: ';
export const UPDATE_WGT_RECORD_STANDARD_SET_FIXED_WGT = 'Fixed Weight';
export const UPDATE_WGT_RECORD_ACTION_1 = 'Apply';
export const UPDATE_WGT_RECORD_ACTION_2 = 'Cancel';
export const SET_THRESHOLD_TITLE = 'Set weight threshold';
export const CLEAN_WEIGHT_RECORD = 'Clean Weight Record';
export const REMOVE_ALL_WEIGHTS = 'Remove all weights';
export const KEEP_LIGHT_WEIGHTS_ONLY = 'Keep only light weights (< 5 clbs)';
export const KEEP_MEDIUM_WEIGHTS_ONLY =
  'Keep only medium weights (>= 5 clbs and <= 10 clbs)';
export const KEEP_HEAVY_WEIGHTS_ONLY = 'Keep only heavy weights (> 10 clbs)';
export const SET_THRESHOLD_ITEM_NAME = 'Item: ';
export const SET_THRESHOLD_ITEM_BARCODE = 'Barcode: ';
export const SET_THRESHOLD_WGTS = 'Weights';
export const SET_THRESHOLD_STANDARD_WGT = 'Recommended threshold: ';
export const SET_THRESHOLD_STANDARD_WGT_UNIT = 'clbs';
export const SET_THRESHOLD_STANDARD_SET_WGT = 'Set threshold: ';
export const SET_THRESHOLD_ACTION_1 = 'Apply';
export const SET_THRESHOLD_ACTION_2 = 'Cancel';
export const REFRESH = 'Refresh';
export const FILTER_END_DATE_TIME = 'Use current date/time';
export const REFRESH_RATE = 'Refresh Rate';
export const REFRESH_DISABLED = 'Disabled';
export const ONE_MINUTE = '1 minute';
export const FIVE_MINUTES = '5 minutes';
export const FIFTEEN_MINUTES = '15 minutes';
export const THIRTY_MINUTES = '30 minutes';
export const ONE_HOUR = '1 hour';
export const LOADING = 'Loading';
export const SELECT_COMMAND = 'Select Command';
export const EXPORT_TO_EXCEL = 'Export to Excel';
export const EXPORT_TO_PDF = 'Export to PDF';
export const EXPORT_TO_CSV = 'Export to CSV';
export const IMPORT_CSV = 'Import CSV';
export const UPLOAD = 'Upload';
export const INVALID_FILE_FORMAT = 'Invalid file format';
export const REFERENCE_WEIGHTS = 'ReferenceWeights';
export const REFERENCE_WEIGHTS_MANAGEMENT = 'Reference Weights Management';
export const FAILED_TO_LOAD_THE_FILE = 'Failed to load the file';
export const WEIGHTS = 'Weights';
export const STORE = 'Store: ';
export const LANE = 'Lane: ';
export const EXPORT_DATETIME = 'Export DateTime: ';
export const READY_TO_UPLOAD = 'Ready to upload';
export const IMPORT_SUCCESS_TEXT =
  'Successfully imported the reference weights data';
export const IMPORT_FAIL_TEXT = 'Failed to import the reference weights data';
export const UPLOADING = 'Uploading';
export const SELECT_ALL = 'Select All';
export const UNSELECT_ALL = 'Unselect All';
export const ASSETS_OVERVIEW = 'Assets Overview';
export const STORES = 'Stores';
export const LANES_BY_SYSTEM_TYPE = 'Lanes by system type';
export const TOTAL = 'Total';
export const CLUSTER = 'Cluster: ';
export const DIVISION = 'Division: ';
export const STATION_TYPE = 'Station Type: ';
export const ASSETS = 'Assets: ';
export const BACK = 'Back';
export const COLUMN_TITLE_STORE = 'Store';
export const COLUMN_TITLE_CLUSTER = 'Cluster';
export const COLUMN_TITLE_LANE = 'Lane';
export const COLUMN_TITLE_DIVISION = 'Division';
export const COLUMN_TITLE_LANE_TYPE = 'Type';
export const COLUMN_TITLE_LANE_ASSETS = 'Assets';
export const COLUMN_TITLE_LANE_NAME = 'Name';
export const COLUMN_TITLE_LANE_CATEGORY = 'Category';
export const COLUMN_TITLE_LANE_VALUE = 'Value';
export const COLUMN_TITLE_FAILURE = 'Failure';
export const COLUMN_TITLE_CREATED_ON = 'Created On';
export const COLUMN_TITLE_STATUS = 'Status';
export const COLUMN_TITLE_ETA = 'ETA';
export const COLUMN_TITLE_ACTIONS = 'Actions';
export const COLUMN_TITLE_COMMANDS = 'Commands';
export const CLOSE_TICKET = 'Close Ticket';
export const VIEW = 'View';
export const LAST_REFRESHED = 'Last Refreshed: ';
export const NODE_ID = 'Node ID: ';
export const DOWNLOAD_ASSETS = 'Export to CSV';
export const RUN_QUERY = 'Run Query';
export const COLLAPSE_GROUPS = 'Collapse Groups';
export const EXPAND_GROUPS = 'Expand Groups';
export const OVERVIEW_SECTION = 'Overview';
export const SHOW_ALERTS_SUMMARY = 'Show Alerts summary';
export const SHOW_ASSETS_SUMMARY = 'Show Assets summary';
export const ALERTS_OVERVIEW = 'Alerts Overview';
export const LANE_COUNT = 'Lane count: ';
export const FETCH_ERROR_MESSAGE_ASSETS = 'Failed to fetch assets ';
export const FETCH_ERROR_MESSAGE_ASSET_STATUSES =
  'Failed to fetch device statuses ';
export const FETCH_ERROR_MESSAGE_NODE_VERSION_INFO =
  'Failed to fetch version info';
export const FETCH_ERROR_MESSAGE_REPORTS = 'Failed to fetch reports';
export const FETCH_ERROR_MESSAGE_TICKETS = 'Failed to fetch tickets';
export const CLOSE_ERROR_MESSAGE_TICKETS = 'Failed to close ticket';
export const ONLINE = 'Online';
export const OFFLINE = 'Offline';
export const STATUS = 'Status';
export const CURRENT_ISSUE = 'Current Issue';
export const REPORTS = 'Report: ';
export const CATEGORY = 'Category: ';
export const DATE_RANGE = 'Date Range: ';
export const ITEMS_SELECTED = 'selected';
export const OK_BUTTON = 'Ok';
export const CANCEL_BUTTON = 'Cancel';
export const TODAY = 'Today';
export const YESTERDAY = 'Yesterday';
export const LAST_SEVEN_DAYS = 'Last 7 days';
export const OTHER = 'Other...';
export const DRILLDOWN_ITEM = 'DrilldownItem';
export const DRILLDOWN = 'Drilldown';
export const NBC_ITEM = 'NBC Item';
export const NBC_DRILLDOWN = 'NBC Drilldown';

export const ASSET = {
  FIELD_ASSETINFO_LABEL: 'Asset',
  FIELD_STORE_LABEL: 'Store',
  FIELD_CLUSTER_LABEL: 'Cluster',
  FIELD_LANE_LABEL: 'Lane',
  FIELD_DIVISION_LABEL: 'Division',
  FIELD_STATUS_LABEL: 'Status',
  FIELD_PRIORITY_LABEL: 'Priority',
  FIELD_CATEGORY_LABEL: 'Category',
  FIELD_MODEL_LABEL: 'Model',
  FIELD_FAILURE_CODE_LABEL: 'Failure Code',
  FIELD_MAINTENANCE_TYPE_LABEL: 'Maintenance Type',
  FIELD_ASSETINFO_NAME: 'AssetInfo',
  FIELD_STORE_NAME: 'SiteNumber',
  FIELD_CLUSTER_NAME: 'NodeGroup',
  FIELD_LANE_NAME: 'LaneNumber',
  FIELD_DIVISION_NAME: 'Division',
  FIELD_NODETYPE_NAME: 'NodeType',
  FIELD_STATUS_NAME: 'AssetStateInfo',
  CURRENT_ISSUE: 'CurrentIssue',
  FIELD_OFFLINE_NAME: 'Offline',
  FIELD_PRIORITY_NAME: 'Priority',
  FIELD_CATEGORY_NAME: 'Category',
  FIELD_MAINTENANCE_CATEGORY_NAME: 'UnitName',
  FIELD_MODEL_NAME: 'Model',
  FIELD_FAILURE_CODE_NAME: 'FailureCode',
  FIELD_MODULE_NAME: 'Module',
  FIELD_PARTNAME_NAME: 'PartName',
  FIELD_ACTION_NAME: 'Action',
  FIELD_MAINTENANCE_TYPE_NAME: 'MaintenanceType',
  FIELD_MAINTENANCE_ACTION_NAME: 'Recommendation',
  FIELD_ERROR_STATE: 'ErrorState',
  FIELD_CONFIG_SETTING: 'ConfigSetting',
  FIELD_STORE_NUMBER: 'StoreNumber',
  FIELD_CUSTOMER_NAME: 'CustomerName',
  FIELD_REPORT_NAME: 'ReportID',
  FIELD_DATE_RANGE: 'DateRange',
  FIELD_START_DATE: 'StartDate',
  FIELD_END_DATE: 'EndDate',
  FIELD_LANGUAGE: 'Language',
  VALUE_PLACEHOLDER: 'Value',
  NAME_PLACEHOLDER: 'Name',
  CATEGORY_PLACEHOLDER: 'Category',
  STORE_PLACEHOLDER: 'Select Store',
  DIVISION_PLACEHOLDER: 'Select Division',
  STATUS_PLACEHOLDER: 'Select Status',
  BUILD_NUMBER: 'BuildNumber',
  PACKAGE_NAME: 'PackageName',
  IMAGE_VERSION: 'ImageVersion',
  DELIVERY_CODE: 'DeliveryCode',
  LANE_STATUS: 'LaneStatus',
};

// PAGES TITLE
export const PAGE_TITLE_OVERVIEW = 'Overview';
export const PAGE_TITLE_ALERTS = 'Alerts';
export const PAGE_TITLE_DEVICES = 'Devices';
export const PAGE_TITLE_ASSETS = 'Assets';
export const PAGE_TITLE_AI = 'AI';
export const PAGE_TITLE_REPORTS = 'Reports';
export const PAGE_TITLE_NBC = 'NBC';
export const PAGE_TITLE_TICKETS = 'Tickets';
export const PAGE_TITLE_HEALTH = 'Health';
export const PAGE_TITLE_CONFIG = 'Config';
export const PAGE_TITLE_NOTIFICATION = 'Notifications';
export const PAGE_TITLE_HELP = 'Help';
export const PAGE_TITLE_REGISTRATION = 'Registration';
export const PAGE_TITLE_SIGNIN = 'Sign In';
export const PAGE_TITLE_WORKINPROGRESS = 'Work In Progress';
export const PAGE_TITLE_SETTINGS = 'Settings';
export const PAGE_TITLE_DEVICE_TRENDS = 'Trends';

// UI CONSTANTS
export const FOOTER_HEIGHT = 30;
export const DRAWER_WIDTH = 210;

// ALERT PAGE TIMER
export const ALERTS_REFRESH_RATE = {
  DISABLED: -1,
  ONE_MINUTE: 60000,
  FIVE_MINUTES: 300000,
  FIFTEEN_MINUTES: 900000,
  THIRTY_MINUTES: 1800000,
  ONE_HOUR: 3600000,
};

export const ASSET_NAME_DEFAULT_FETCH_SIZE_BY_BLOCK = 500;
export const ASSET_NAME_SERIAL_NUMBER_FETCH_SIZE_BY_BLOCK = 500;
export const ASSET_NAME_HDD_FREE_SPACE_FETCH_SIZE_BY_BLOCK = 100;

// REFERENCE WEIGHT IMPORT PAYLOAD MAX
export const REFERENCE_WEIGHTS_PAYLOAD_MAX = 250;

export const MAX_DAYS_FOR_ONLINE_STATUS = 2;

export const ACTIVE_THRESHOLD_DATA = [1, 2, 3, 5, 10];

export const operators = [
  { text: 'OPERATOR_EQUAL', operator: 'contains' },
  {
    text: 'OPERATOR_IS_NOT_EQUAL',
    operator: 'doesnotcontain',
  },
  { text: 'OPERATOR_IS_AFTER_OR_EQUAL_TO', operator: 'gte' },
  { text: 'OPERATOR_IS_AFTER', operator: 'gt' },
  { text: 'OPERATOR_IS_BEFORE', operator: 'lt' },
];

export const STORE_CLUSTER_LANE_SELECTOR_COMMANDS = {
  SET_ALL_WEIGHTS_TO_DEFAULT: 'SET_ALL_WEIGHTS_TO_DEFAULT',
  APPLY_NBC_SNAPSHOT: 'APPLY_NBC_SNAPSHOT',
  APPLY_CONFIGURATION: 'APPLY_CONFIGURATION',
  REQUEST_LOGS: 'REQUEST_LOGS',
  SCHEDULE_UPLOAD_LOGS: 'SCHEDULE_UPLOAD_LOGS',
  CONFIG_ACCESS_CONTROL: 'CONFIG_ACCESS_CONTROL',
  SCHEDULE_SET_ALL_WEIGHTS_TO_DEFAULT: 'SCHEDULE_SET_ALL_WEIGHTS_TO_DEFAULT',
  SCHEDULE_CONFIG_ACCESS_CONTROL: 'SCHEDULE_CONFIG_ACCESS_CONTROL',
};

// NOTIFICATIONS PAGE CONSTANTS
export const TEXT_MESSAGE_FIELD_MASK = '0000000000';

export const FEAURES_ENTRY_TYPE = {
  RegEntryDword: 'RegEntryDword',
  RegEntryDwordMulti: 'RegEntryDwordMulti',
  RegEntryString: 'RegEntryString',
  RegEntryDwordHex: 'RegEntryDwordHex',
};

export const COMMAND_NAME = {
  SCHEDULE_SET_ALL_WEIGHT_TO_DEFAULT: 'ScheduleSetAllWeightRecordsToDefault',
  SCHEDULE_UPLOAD_LOGS: 'ScheduleUploadLogs',
  SCHEDULE_CONFIG_ACCESS_CONTROL: 'ScheduleConfigAccessControl',
};

// ARTIFACTS PAGE CONSTANTS
export const DEFAULT_PRODUCT_GROUP = 'PROD';
export const DEFAULT_PRODUCT_NAME = 'Product';
export const DEFAULT_CHUNK_SIZE_BYTES = 5 * 1024 * 1024;
export const MAX_VISIBLE_UPLOAD_NOTIFICATIONS = 2;
export const COMPLETED_NOTIFICATION_TIMEOUT_MS = 2000;
export const ERROR_NOTIFICATION_TIMEOUT_MS = 3000;

export const ARCH_ALIASES: Record<string, string> = {
  arm64: 'linux-arm64',
  amd64: 'linux-amd64',
  x64: 'linux-amd64',
};

export const FORM_DATA_KEYS = {
  uploadId: 'uploadId',
  sessionId: 'sessionId',
  fileName: 'fileName',
  filePath: 'filePath',
  type: 'type',
  repository: 'repository',
  chunkIndex: 'chunkIndex',
  totalChunks: 'totalChunks',
  chunk: 'chunk',
  version: 'version',
  package: 'package',
  sha256: 'sha256',
} as const;

export const XML_SCHEMA = {
  rootNode: 'SDKConfig',
  componentVersionSelector: 'SDKConfig > ComponentVersion',
  componentSelector: 'SDKComponentsList > Component',
  attributes: {
    productName: 'SDKProductName',
    productVersion: 'SDKProductVersion',
    name: 'Name',
    version: 'Version',
    install: 'Install',
    type: 'Type',
    repo: 'Repo',
    package: 'Package',
    fileName: 'FileName',
    sha256: 'SHA256',
  },
} as const;

export const VALID_COMPONENT_TYPES = new Set([
  'DockerImage',
  'ConfigArchive',
  'ComposeYaml',
  'GenericFile',
]);

export const VALID_INSTALL_VALUES = new Set(['true', 'false']);

export const NBC_IMAGE_IMPORT_BATCH_SIZE = 50;
